const styles = () => ({
  root: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'auto',
    maxWidth: '80vw',
  },

  response: {
    maxWidth: '60%',
  },

  risky: {
    color: '#f44336',
  },

  tooltipContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  deleteResponse: {
    cursor: 'pointer',
  },

  responseTitleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
});

export default styles;
